<script>
  import tippy from 'tippy.js';
  import WelcomeNoteModal from './modal/WelcomeNoteModal.svelte';
  import { getCurrentUserStore } from '@stores/current_user';
  import { getGroupStore } from '@stores/group';
  let groupStore = getGroupStore('groupStore');

  import { getProfileStore } from '@stores/profile';
  let groupsStore = getProfileStore('groupsStore');

  import { onMount } from 'svelte';

  export let tooltipMessageContent = 'Welcome note is active';
  export let location;
  export let groupId;
  export let mobile = false;

  let group;
  let currentUser = getCurrentUserStore('default');
  let showWelcomeNoteModal = false;
  let welcomeNoteEditMode = false;

  let setupTippy = (node, data) => {
    if (mobile) {
      return;
    }

    let instance = tippy(node, {
      content: data,
    });

    return {
      destroy() {
        try {
          instance.destroy();
        } catch {}
      },
    };
  };

  let showWelcomeNote = function (edit) {
    showWelcomeNoteModal = true;

    if (!mobile) {
      welcomeNoteEditMode = edit;
    }
  };

  onMount(() => {
    group = groupId ? groupsStore.find(groupId) : groupStore;
    let unsubGroup = group.subscribe((x) => (group = x));

    return () => {
      unsubGroup();
    };
  });
</script>

<style style="text/scss" lang="scss">
  // @todo scope new changes to a flag to be used on new tile

  .welcome-active {
    margin-right: 6px;
    cursor: pointer;

    &.profile-cover-photos {
      padding-top: 10.5px;

      &.mobile {
        padding-top: 10px;
        margin-right: 6px;
      }
      > a > img {
        height: 20px;
      }
    }

    &.profile-new {
      padding-top: 14px;
      &.mobile {
        padding-top: 12px;
        margin-right: 8px;
      }
      > a > img {
        height: 20px;
      }
    }
    &.profile {
      padding-top: 9px;
      &.mobile {
        padding-top: 10px;
        margin-right: 8px;
      }
      > a > img {
        height: 18px;
      }
    }
  }
</style>

{#if group && group.permissions.edit && group.welcome_note_enabled}
  <div
    class="welcome-active"
    class:profile={location === 'profile'}
    class:profile-new={location === 'profileNew'}
    class:profile-cover-photos={location === 'profileCoverPhotos'}
    class:mobile={mobile}
    use:setupTippy={tooltipMessageContent}>
    {#if showWelcomeNoteModal}
      <WelcomeNoteModal
        group={group}
        mobile={mobile}
        currentUser={currentUser}
        on:close={() => {
          showWelcomeNoteModal = false;
        }}
        bind:edit={welcomeNoteEditMode} />
    {/if}
    <a
      href="#"
      on:click|preventDefault|stopPropagation={() => {
        showWelcomeNote(false);
      }}
      class="welcome-note-modal-link">
      <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
        <path
          d="M15 2C16.6569 2 18 3.34315 18 5V12C18 15.3137 15.3137 18 12 18H5L4.8457 17.9961C3.26055 17.9158 2 16.6051 2 15V5C2 3.34315 3.34315 2 5 2H15ZM5 3.5C4.17157 3.5 3.5 4.17157 3.5 5V15C3.5 15.8284 4.17157 16.5 5 16.5H11.6279V14.8135C11.6282 13.1091 12.9671 11.717 14.6504 11.6318L14.8135 11.6279H16.5V5C16.5 4.17157 15.8284 3.5 15 3.5H5ZM14.8135 13.1279C13.8828 13.1283 13.1282 13.8828 13.1279 14.8135V16.2627C14.6118 15.7828 15.7839 14.6118 16.2637 13.1279H14.8135ZM13.0742 7.96777L10.3896 11.0459C9.77293 11.7529 8.70761 11.8475 7.97559 11.2607L6.95996 10.4463L7.89941 9.27637L8.91406 10.0908C9.0185 10.1741 9.17076 10.1611 9.25879 10.0605L11.9434 6.98145L13.0742 7.96777Z"
          fill="#1A1A1A" />
      </svg>
    </a>
  </div>
{/if}
